import { SLOT_MINUTES } from '../resourceModel';

/** Tage im Sperren-Blatt deutsch („Mi., 2. Jan.“), als Kalendertag gelesen. */
export const sheetDay = new Intl.DateTimeFormat('de-DE', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
});

/** Halbe Stunden von bis einschließlich – die Wahl für „Von“ und „Bis“. */
export function slotRange(from: number, to: number): number[] {
  const values: number[] = [];
  for (let minute = from; minute <= to; minute += SLOT_MINUTES) values.push(minute);
  return values;
}

interface Hours {
  opensAtMinute: number;
  closesAtMinute: number;
}

/**
 * Rückt eine Zeit in das Fenster einer Ressource: Beginn auf die letzte mögliche halbe Stunde,
 * Ende danach und höchstens bis zum Schließen. So zeigt das Blatt immer, was gesendet wird.
 */
export function fitWindow(startMinute: number, endMinute: number, hours: Hours) {
  const start = Math.min(
    Math.max(startMinute, hours.opensAtMinute),
    hours.closesAtMinute - SLOT_MINUTES,
  );
  const end = Math.min(Math.max(endMinute, start + SLOT_MINUTES), hours.closesAtMinute);
  return { startMinute: start, endMinute: end };
}

/** Liegt eine markierte Zeit ganz im Fenster? Sonst gilt die Markierung nicht mehr. */
export function insideWindow(startMinute: number, endMinute: number, hours: Hours): boolean {
  return (
    startMinute >= hours.opensAtMinute &&
    endMinute <= hours.closesAtMinute &&
    endMinute > startMinute
  );
}
